<template>
  <div class="container login-form-container">
    <ul class="nav nav-pills nav-justified" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          :class="tabClass('personalData')"
          id="personal-tab"
          data-bs-toggle="pill"
          data-bs-target="#personal"
          type="button"
          @click.prevent="toggleTab('personalData')"
          aria-controls="personal"
          aria-selected="true"
        >
          <span v-if="isMobile == 0 || activeTab('personalData')">{{ transPeralbaPro.item816 }}</span>
          <span v-else>{{ transPeralbaPro.item817 }}</span>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          :class="tabClass('accessData')"
          id="access-tab"
          data-bs-toggle="pill"
          data-bs-target="#access"
          type="button"
          @click.prevent="toggleTab('accessData')"
          aria-controls="access"
          aria-selected="false"
        >
          <span v-if="isMobile == 0 || activeTab('accessData')">{{ transPeralbaPro.item818 }}</span>
          <span v-else>{{ transPeralbaPro.item819 }}</span>
        </button>
      </li>
    </ul>

    <div class="tab-content" id="myTabContent">
      <particular-register-personal-data
        v-show="tabs.personalData"
        :active-tab="activeTab('personalData')"
        :name="form.name"
        :surname="form.surname"
        :nif="form.nif"
        :email="form.email"
        :mobile="form.mobile"
        :phone="form.phone"
        :errors="errors"
        :trans-peralba-pro="transPeralbaPro"
        @updateField="updateField"
        @validateRegisterPersonalData="validateRegisterPersonalData"
      />
      <particular-register-access-data
        v-show="tabs.accessData"
        :active-tab="activeTab('accessData')"
        :email="form.email"
        :password="form.password"
        :selected-lang="form.selectedLang"
        :newsletter="form.newsletter"
        :newsletter-interests="form.newsletterInterests"
        :legal="form.legal"
        :languages="languages"
        :activities="activities"
        :route-legal="routeLegal"
        :route-privacy="routePrivacy"
        :disabledForm="disabledForm"
        :errors="errors"
        :trans-peralba-pro="transPeralbaPro"
        @updateField="updateField"
        @crearCuenta="validateRegisterAccessData"
        @goToDatosPersonales="toggleTab('personalData')"
      />
    </div>
  </div>
</template>
<script>
import navigation from "../mixins/navigation";
import HTTP from "../../../../services/http";
import validation from "../mixins/validation";
import ParticularRegisterPersonalData from "../components/ParticularRegister/ParticularRegisterPersonalData";
import ParticularRegisterAccessData from "../components/ParticularRegister/ParticularRegisterAccessData";

export default {
  components: { ParticularRegisterPersonalData, ParticularRegisterAccessData },
  mixins: [navigation, validation],
  props: [
    "email",
    "languages",
    "activities",
    "legal",
    "routeLegal",
    "routePrivacy",
    "routeRegister",
    "disabledForm",
    "defaultSelectedLang",
    "isMobile",
    "transPeralbaPro",
  ],
  data() {
    return {
      form: {
        name: "",
        surname: "",
        nif: "",
        mobile: "",
        phone: "",
        email: "",
        password: "",
        selectedLang: null,
        newsletter: false,
        newsletterInterests: [],
        legal: false,
        professional: false,
      },
      errors: {
        personalData: [],
        accessData: [],
      },
      tabs: {
        personalData: true,
        accessData: false,
      },
    };
  },
  created() {
    this.form.email = this.email;
    this.form.selectedLang = this.defaultSelectedLang;
  },
  mounted() {
    for (let activity of this.activities) {
      this.form.newsletterInterests.push(activity.id);
    }
  },
  methods: {
    tabClass(tab) {
      let classExtraTab = this.activeTab(tab) ? "active" : "";
      return `nav-link ${classExtraTab}`;
    },
    activeTab(tab) {
      return !!this.tabs[tab];
    },
    toggleTab(tab) {
      this.tabs.personalData = tab == "personalData";
      this.tabs.accessData = tab == "accessData";
    },
    updateField(event) {
      this.form[event.field] = event.value;
    },

    validateRegisterPersonalData() {
      this.validateTextField("personalData", "name");
      this.validateTextField("personalData", "surname");
      this.validateNifField("personalData", "nif");
      this.validateEmailField("personalData", "email");
      this.validatePhoneField("personalData", "mobile");
      this.validatePhoneField("personalData", "phone", false);

      if (this.errors.personalData.length === 0) {
        this.toggleTab("accessData");
      }
    },
    validateRegisterAccessData() {
      this.validateEmailField("accessData", "email");
      this.validateTextField("accessData", "password");
      this.validateSelectField("accessData", "selectedLang");
      this.validateCheckboxField("accessData", "legal");

      if (
        this.errors.accessData.length === 0 &&
        this.errors.personalData.length === 0
      ) {
        this.registerParticular();
      }
    },
    async registerParticular() {
      this.$emit("loading", true);
      try {
        const response = await HTTP.post(this.routeRegister, this.form);
        if (response.data.status == 1) {
          this.$emit("changeView", 6);
          this.$emit("showFirst", true);
        } else {
          this.errors.push(response.data);
        }
        this.$emit("loading", false);
      } catch (e) {
        this.$emit("loading", false);
      }
    },
  },
};
</script>
